import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import { type Filters, type Insight } from "../types";
import { type FilterConfig, FilterSection } from "./FilterSection";

type Props = {
  filterConfigs: FilterConfig[];
  filters: Filters;
  insights: Insight[] | undefined;
  newExpandedSections?: Record<string, boolean>;
  onFilterChange: (category: keyof Filters, value: string) => void;
};

const FilterSectionsList: React.FC<Props> = ({
  filterConfigs,
  filters,
  insights,
  newExpandedSections,
  onFilterChange,
}) => {
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});

  // TODO: Remove this, as well as newExpandedSections prop, after Appcues modal has served it's purpose: [CMP-29055]
  useEffect(() => {
    if (newExpandedSections) {
      setExpandedSections(newExpandedSections);
    }
  }, [newExpandedSections]);

  const handleExpandFiltersChange = (title: string, isExpanded: boolean) => {
    setExpandedSections((prev) => ({
      ...prev,
      [title]: isExpanded,
    }));
  };

  return (
    <Box sx={{ width: { xs: "100%", md: 280 }, mb: { xs: 3, md: 0 }, mr: { md: 3 } }}>
      {filterConfigs.map((config) => (
        <FilterSection
          key={config.title}
          config={config}
          filters={filters}
          expandedFilters={expandedSections}
          isExpanded={expandedSections[config.title] ?? config.isExpandedByDefault}
          onFilterChange={onFilterChange}
          onExpandChange={handleExpandFiltersChange}
          insights={insights}
        />
      ))}
    </Box>
  );
};

export default FilterSectionsList;
